<template>
  <el-dialog :visible.sync="isShow" width="1000px" top="10px" :close-on-click-modal="false" append-to-body destroy-on-close>
    <iframe ref="awsWindow" v-if="iframeSrc && isShow" :src="iframeSrc" class="iframe" style="height: calc(100vh - 160px);"></iframe>
  </el-dialog>
</template>

<script>
export default {
  name: "IframeView",
  props: {},
  components: {},
  data() {
    return {
      isShow: false,
      iframeTitle: "",
      iframeSrc: "",
    };
  },
  methods: {
    showIframe(src, title) {
      this.iframeTitle = "";
      this.iframeSrc = "";

      this.$nextTick(() => {
        if (src) {
          const newSrc =
            src.indexOf("?") > -1
              ? src + "&time=" + Date().now
              : src + "?time=" + Date().now;

          this.iframeTitle = title || "";
          this.iframeSrc = newSrc;
          this.isShow = true;
        } else {
          this.$message.error("请求参数不正确");
        }
      });
    },
  },
  watch: {},
};
</script>

<style>
.theme-blue .el-dialog__body {
  padding: 10px 20px;
}

.iframe {
  width: 100%;
  height: 100%;
  border: none;
} 
</style>
